import type { AvailableColumn } from "@/api/types";

/**
 * Hardcoded column catalog for the Contacts page. Contacts aren't
 * project_type-driven (the shape doesn't change between cfo and m&a
 * projects), so we don't fetch a backend catalog for them. The shape
 * matches AvailableColumn so the same ColumnSelector / hook can be
 * reused. `key` matches the existing ContactTable column ids exactly
 * for the simple cases, and uses the canonical Contact attribute name
 * otherwise (so a backend-driven catalog could replace this list later
 * without UI changes).
 */
export const CONTACT_COLUMNS: AvailableColumn[] = [
  // Anchor — name is locked, always present.
  {
    key: "full_name",
    label: "Name",
    default: true,
    locked: true,
    type: "text",
  },
  {
    key: "company",
    label: "Company",
    default: true,
    locked: false,
    type: "text",
  },
  { key: "email", label: "Email", default: true, locked: false, type: "text" },
  {
    key: "title",
    label: "Title",
    default: false,
    locked: false,
    type: "text",
  },
  { key: "phone", label: "Phone", default: false, locked: false, type: "text" },
  {
    key: "linkedin_url",
    label: "LinkedIn",
    default: false,
    locked: false,
    type: "text",
  },
  {
    key: "is_decision_maker",
    label: "DM",
    default: true,
    locked: false,
    type: "badge",
  },
  {
    key: "enrichment_status",
    label: "Enrichment",
    default: false,
    locked: false,
    type: "badge",
  },
  {
    key: "source",
    label: "Source",
    default: false,
    locked: false,
    type: "text",
  },
  {
    key: "created_at",
    label: "Created",
    default: false,
    locked: false,
    type: "date",
  },
  {
    key: "updated_at",
    label: "Updated",
    default: true,
    locked: false,
    type: "date",
  },
];
